import React from 'react'

import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import { IOnboardingChecklistProps } from './interface'
import OnboardingChecklistItems from './OnboardingChecklistItems'
// @ts-ignore
import { MAX_TABLET_DEVICE_WIDTH } from 'app/constants/screenSizes'
import './styles.scss'

export const bc = 'onboarding-check-list'

const OnboardingChecklist = (props: IOnboardingChecklistProps) => {
  const { showModal, completedNumber, availableOrgFeatureNumber, windowWidth } = props
  const isMobile = windowWidth <= MAX_TABLET_DEVICE_WIDTH
  const mobileIconProps = {
    background: '#2ED8A7',
    circleborder: '#2ED8A7',
    checkcolor: '#ffffff',
    style: { position: 'absolute', left: 30, top: 30 },
  }
  if (completedNumber === availableOrgFeatureNumber) {
    return null
  }

  if (isMobile) {
    return (
      <div
        className={`${bc}__wrapper-circle`}
        onClick={() =>
          showModal(<OnboardingChecklistItems {...props} />, { size: 'xxs', title: 'Onboarding Checklist' })
        }
      >
        <span className={`${bc}__completed-number`}>
          {completedNumber}/{availableOrgFeatureNumber}
        </span>
        <AvailableDomain {...mobileIconProps} />
      </div>
    )
  }

  return <OnboardingChecklistItems {...props} />
}

export default OnboardingChecklist
